import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { filterIconChipStyle } from '../Filter.style';
import { Chip } from '../../Chip';
export const Toggle = ({ dataQa, label, onSendFilter, paginationData, filterToggle: isChecked, setFilterToggle: setIsChecked }) => {
    const handleChange = () => {
        onSendFilter(!isChecked);
        setIsChecked(!isChecked);
    };
    useEffect(() => {
        if ((paginationData === null || paginationData === void 0 ? void 0 : paginationData.changePageOnFiltering) && (paginationData === null || paginationData === void 0 ? void 0 : paginationData.setPage)) {
            paginationData.setPage(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isChecked]);
    return (React.createElement(Box, { "data-qa": dataQa },
        React.createElement(Chip, { "data-qa": `${dataQa}-chip`, label: label, onClick: handleChange, variant: "outlined", selected: isChecked, leftIcon: isChecked ? (React.createElement(CheckCircleIcon, { "data-qa": `${dataQa}-iconCancel` })) : (React.createElement(AddCircleIcon, { "data-qa": `${dataQa}-iconAdd`, sx: filterIconChipStyle })) })));
};
